module.exports = __webpack_public_path__ + "static/media/avatar_34.84565870.svg";